import { INSIGHTS_PACKAGE } from '@atlassian/jira-insights-common-constants/src/common/constants/package.tsx';

export const BOARD_BUTTON_ID = `${INSIGHTS_PACKAGE}.board-button`;
